import {
  Mutation,
  TabaPayChallengeLookupInput,
  TabaPayChallengeLookupResult,
  TabaPayChallengeLookupResultTypenames,
} from '@varo/graphql-schema-types';
import { checkError } from 'features/moveMoney/screens/dcf/tabapay/helpers/TabaPay.helpers';
import { useState } from 'react';
import TabaPayChallengeLookup from 'services/graphql/mutations/MoveMoney/TabaPay/ChallengeLookup';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useMutation } from 'urql';

export const useTabaPayChallengeLookup = () => {
  const [{ data, error, fetching }, executeMutation] = useMutation<Mutation>(
    TabaPayChallengeLookup,
  );

  const { defaultTitle, defaultMessage } = useDefaultErrorStrings();
  const [errorScreen, setErrorScreen] = useState<{
    screenType: ErrorScreenType.Error;
    messageHeadline: string;
    messageBody: string;
  } | null>(null);

  const triggerChallengeLookup = async (
    input: TabaPayChallengeLookupInput,
  ): Promise<TabaPayChallengeLookupResult> => {
    const result = await executeMutation({ input });
    if (!result.data) {
      throw new Error('No data returned from challenge init');
    }

    if (
      result.data.tabaPayChallengeLookup.__typename ===
      TabaPayChallengeLookupResultTypenames.TabaPayChallengeLookupResultError
    ) {
      setErrorScreen({
        screenType: ErrorScreenType.Error,
        messageHeadline: result.data.tabaPayChallengeLookup.title,
        messageBody: result.data.tabaPayChallengeLookup.message,
      });
    }

    if (error) {
      const errorObject = checkError(error, defaultTitle, defaultMessage);
      setErrorScreen({
        screenType: ErrorScreenType.Error,
        ...errorObject,
      });
    }
    return result.data.tabaPayChallengeLookup;
  };

  return {
    triggerChallengeLookup,
    triggerChallengeLookupResult: {
      errorScreen,
      data: data?.tabaPayChallengeLookup,
      fetching,
      error,
    },
  };
};
